"use client";

import { AuthProviderButton } from "@/components/auth/auth-provider-button";
import { EmailLoginForm } from "@/components/auth/email-login-form";
import { QaLoginForm } from "@/components/auth/qa-login-section";
import { Icons } from "@/components/icons";
import type { LoginProviderSlot } from "@/lib/auth/resolve-login-providers";
import type { UserLoginValues } from "@/lib/schemas/login";

export type LoginProviderOptionProps = {
  credentialsLoading: boolean;
  disabled: boolean;
  emailFormId?: string;
  emailSubmitLabel?: string;
  googleLoading: boolean;
  isPrimary: boolean;
  onEmailSubmit: (data: UserLoginValues) => Promise<void>;
  onGoogleLogin: () => void;
  slot: LoginProviderSlot;
};

export function LoginProviderOption({
  credentialsLoading,
  disabled,
  emailFormId,
  emailSubmitLabel,
  googleLoading,
  isPrimary,
  onEmailSubmit,
  onGoogleLogin,
  slot,
}: LoginProviderOptionProps) {
  switch (slot) {
    case "google":
      return (
        <AuthProviderButton
          disabled={disabled}
          icon={<Icons.google className="size-4" />}
          label="Continue with Google"
          loading={googleLoading}
          onClick={onGoogleLogin}
          showLastUsed={isPrimary}
        />
      );
    case "email":
      return (
        <EmailLoginForm
          disabled={disabled}
          formId={emailFormId}
          loading={credentialsLoading}
          onSubmit={onEmailSubmit}
          showLastUsed={isPrimary}
          submitLabel={emailSubmitLabel}
        />
      );
    case "qa-login":
      return <QaLoginForm showLastUsed={isPrimary} />;
    default: {
      const _exhaustive: never = slot;
      return _exhaustive;
    }
  }
}
